module.exports = __webpack_public_path__ + "static/img/mp2.082407eb.jpg";